import React, { useEffect, useState } from "react";
import { api, fmtDate } from "@finance/lib/api";
import Layout, { PageHeader } from "@finance/components/Layout";
import UploadDialog from "@finance/components/UploadDialog";
import { Button } from "@finance/components/ui/button";
import { UploadSimple, CheckCircle, Clock } from "@phosphor-icons/react";

const TYPE_LABEL = (t) => t?.replace(/_/g, " ");

const FILTERS = [
  { key: "all", label: "All", match: () => true },
  { key: "signed_dn", label: "Signed DNs", match: (d) => (d.document_type || "").startsWith("Signed_DN_") },
  { key: "signed_grvni", label: "Signed GRVNIs", match: (d) => (d.document_type || "").startsWith("Signed_GRV_") },
];

export default function DocumentInbox() {
  const [docs, setDocs] = useState([]);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/documents").then((r) => setDocs(r.data));
  useEffect(() => { load(); }, []);

  const activeFilter = FILTERS.find((f) => f.key === filter) || FILTERS[0];
  const shown = docs.filter(activeFilter.match);
  const count = (f) => docs.filter(f.match).length;

  return (
    <Layout>
      <PageHeader
        title="Document Inbox"
        subtitle="OCR ingestion — documents in, data out"
        actions={<Button className="bg-[#1B4383] hover:bg-[#122E5C]" data-testid="upload-doc-btn" onClick={() => { setActive(null); setOpen(true); }}><UploadSimple size={16} className="mr-1" />Upload Document</Button>}
      />
      <div className="p-8">
        <div className="mb-4 flex flex-wrap items-center gap-2" data-testid="doc-filter-bar">
          {FILTERS.map((f) => (
            <Button key={f.key} size="sm" variant={filter === f.key ? "default" : "outline"} data-testid={`doc-filter-${f.key}`} onClick={() => setFilter(f.key)}>
              {f.label} ({count(f)})
            </Button>
          ))}
        </div>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
          {shown.length === 0 && <div className="col-span-full rounded-sm border border-dashed border-gray-200 p-10 text-center text-sm text-gray-400">{filter === "all" ? "No documents yet. Upload a PO, invoice or receipt to auto-extract fields." : `No ${activeFilter.label.toLowerCase()} uploaded yet.`}</div>}
          {shown.map((d) => (
            <button
              key={d.id}
              data-testid={`doc-card-${d.id}`}
              onClick={() => { setActive(d); setOpen(true); }}
              className="rounded-sm border border-gray-200 bg-white p-4 text-left transition-colors hover:border-[#1B4383]"
            >
              <div className="flex items-center justify-between">
                <span className="rounded-sm bg-gray-100 px-1.5 py-0.5 text-xs font-medium text-gray-700">{TYPE_LABEL(d.document_type)}</span>
                {d.manually_confirmed
                  ? <span className="inline-flex items-center gap-1 text-xs text-emerald-600"><CheckCircle size={14} weight="fill" />Confirmed</span>
                  : <span className="inline-flex items-center gap-1 text-xs text-amber-600"><Clock size={14} />Pending</span>}
              </div>
              <div className="mt-2 truncate text-sm font-medium text-gray-900">{d.original_filename}</div>
              <div className="mt-1 text-xs text-gray-500">{d.uploaded_by_name} · {fmtDate(d.uploaded_at)}</div>
              {d.ocr_error && <div className="mt-1 text-xs text-red-500">OCR unavailable for this file</div>}
            </button>
          ))}
        </div>
      </div>
      <UploadDialog open={open} onOpenChange={setOpen} existingDoc={active} onDone={load} />
    </Layout>
  );
}
